module.exports = __webpack_public_path__ + "img/lookbook_4_left.5866b920.png";